import LoginBackground from '../../../../assets/login_bg.png';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    root: {
        height: '100vh',
        backgroundImage: 'url("3409297.jpg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        justifyContent: 'center',
        alignItem: 'center',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    wrapper: {
        height: 'calc(100vh - 72px)',
        backgroundImage: `url(${LoginBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
    },
    loginBox: {
        backgroundColor: '#fff',
        padding: '50px 40px',
        borderRadius: '20px',
        marginTop: '25%',
    },
    loginBtn: {
        backgroundColor: '#021948 !important',
        padding: '10px 16px !important',
        marginTop: '18px !important',
        marginBottom: '10px !important',
    },
    forgotPasswordText: {
        textDecoration: 'none',
        display: 'block',
        textAlign: 'right',
    },
    centerDiv: {
        textAlign: 'center',
    },
    passField: {
        position: 'relative',
        '& input': {
            padding: '16.5px 50px 16.5px 14px',
        },
        '& button': {
            position: 'absolute',
            right: '10px',
            top: '12px',
        },
    },
    pageTitle: {
        color: '#fff',
        fontSize: '50px !important',
        fontWeight: '700 !important',
    },
    pageDescription: {
        paddingRight: '243px !important',
        color: '#fff',
        fontSize: '22px !important',
        marginTop: '35px !important',
    },
    headerBackground: {
        background: '#fff',
    },
    loginContent: {
        textAlign: 'center',
        '& .Mui-disabled': {
            opacity: '0.6',
            cursor: 'not-allowed',
            color: '#FFF !important',
        },
    },
    copyrightText: {
        textDecoration: 'none',
        color: '#FFF',
        fontFamily: 'Inter',
        fontSize: '16px !important',
        fontStyle: 'normal',
        fontWeight: '400 !important',
        lineHeight: '32px',
        textDecorationLine: 'none',
        marginTop: '50px !important',
    },
    atag: {
        color: '#ffffff !important',
    },
    HeaderNav: {
        background: '#fff !important',
        boxShadow: 'none !important',
        color: '#000 !important',
        width: 'calc(100% - 240px) !important',
        marginLeft: '240px',
    },
    fullwidth: {
        background: '#fff !important',
        boxShadow: 'none !important',
        color: '#000 !important',
        width: '100%',
        marginLeft: '0',
    },
    disabledTextField: {
        backgroundColor: '#D3D3D3',
    },
    passwordValid: {
        textAlign: 'left',
        fontSize: '12px',
        '& li': {
            alignItems: 'center !important',
            margin: '4px 0px !important',
            '& li': {
                marginTop: '2px',
            },
        },
    },
}));
